import { ReactElement, useCallback } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'contexts/AuthContext'
import { useIdleTimeout } from 'hooks/useIdleTimeout'

type AuthGuardProps = {
  children: ReactElement
}

function AuthGuard({ children }: AuthGuardProps) {
  const { token, isLoggedIn, logout } = useAuth()
  const location = useLocation()

  const handleTimeout = useCallback(() => {
    logout()
    window.location.href = '/login'
  }, [logout])

  useIdleTimeout({
    idleMs: 30 * 60 * 1000,
    onTimeout: handleTimeout
  })

  if (!token && !isLoggedIn) {
    return <Navigate to="/login" state={{ from: location.pathname }} />
  }

  return children
}

export default AuthGuard
